import cn from 'clsx';
import CheckNaked from '@pkgs/components/assets/icons/small/Check-Naked.svg';
import { Select as BaseSelect } from '@base-ui/react/select';
import { type Align, type Side } from '@base-ui/react/internals/useAnchorPositioning';

import { type SelectItem } from './Select.types';

import styles from './Select.module.css';

type SelectOptionsProps = {
  items: SelectItem[];
  usesButtonWidth: boolean;
  dataTestId?: string;
  side: Side;
  align: Align;
  sideOffset: number;
};

export const SelectOptions = ({ items, usesButtonWidth, dataTestId, side, align, sideOffset }: SelectOptionsProps) => (
  <BaseSelect.Portal data-search-modules-select-portal="">
    <BaseSelect.Backdrop className={styles.backdrop} />
    <BaseSelect.Positioner side={side} align={align} sideOffset={sideOffset} alignItemWithTrigger={false} className={styles.positioner}>
      <BaseSelect.Popup
        className={cn(styles.popup, usesButtonWidth && styles.matchTriggerWidth)}
        data-testid={dataTestId ? `${dataTestId}_popover` : 'search-components_select_popover'}
      >
        <BaseSelect.List className={styles.list} data-testid={dataTestId ? `${dataTestId}_listbox` : 'search-components_select_listbox'}>
          {items.map((item) => (
            <BaseSelect.Item
              key={item.id}
              value={item.id}
              className={styles.listItem}
              data-nested={item.nested}
              data-parent={item.parent}
              data-testid={item.id}
              label={typeof item.label === 'string' ? item.label : item.description}
            >
              <span className={styles.value}>
                <BaseSelect.ItemText>{item.label}</BaseSelect.ItemText>
                {item.icon}
              </span>
              <BaseSelect.ItemIndicator>
                <CheckNaked aria-hidden="true" />
              </BaseSelect.ItemIndicator>
            </BaseSelect.Item>
          ))}
        </BaseSelect.List>
      </BaseSelect.Popup>
    </BaseSelect.Positioner>
  </BaseSelect.Portal>
);
